import React from "react";
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
} from "@chakra-ui/react";

const CustomAlertDialog = ({
  isOpen,
  onClose,
  title,
  content,
  cancelButtonText,
  confirmButtonText,
  cancelButtonColor,
  confirmButtonColor,
  onConfirm,
}) => {
  return (
    <AlertDialog isOpen={isOpen} onClose={onClose}>
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader>{title}</AlertDialogHeader>
        <AlertDialogBody>{content}</AlertDialogBody>
        <AlertDialogFooter>
          <Button onClick={onClose} colorScheme={cancelButtonColor}>
            {cancelButtonText}
          </Button>
          <Button
            ml={3}
            onClick={() => {
              onConfirm();
              onClose();
            }}
            color="white"
            bg={confirmButtonColor}
            _hover={{ bg: confirmButtonColor }}
          >
            {confirmButtonText}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default CustomAlertDialog;
